import { render, staticRenderFns } from "./ViewPDF.vue?vue&type=template&id=257b7efc&scoped=true&"
import script from "./ViewPDF.vue?vue&type=script&lang=ts&"
export * from "./ViewPDF.vue?vue&type=script&lang=ts&"
import style0 from "./ViewPDF.vue?vue&type=style&index=0&id=257b7efc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257b7efc",
  null
  
)

export default component.exports